import { WebsocketMessage } from 'app/types';

import FileGenerated from '../updates-actions/FileGenerated';
import InspectionFileDownloaded from '../updates-actions/InspectionFileDownloaded';
import InspectionFiles from '../updates-actions/InspectionFiles';
import InspectionsHistory from '../updates-actions/InspectionsHistory';

export interface UpdatesListenerActionsProps {
  message: WebsocketMessage;
}

/**
 * Split messages into actions
 * @param props
 * @returns
 */
export default function UpdatesListenerActions(
  props: UpdatesListenerActionsProps
) {
  const { message } = props;

  /**
   * PDF File For Certificate
   */
  if (message.type === 'pdf_generated') {
    return <FileGenerated type="pdf" message={message} />;
  }

  /**
   * CSV File Generated
   */
  if (message.type === 'csv_generated') {
    return <FileGenerated type="csv" message={message} />;
  }

  /**
   * Get permit history
   */
  if (message.type === 'inspections_history') {
    return <InspectionsHistory message={message} />;
  }

  /**
   * Get permit history inspection files
   */
  if (message.type === 'inspection_files') {
    return <InspectionFiles message={message} />;
  }

  /**
   * Get permit history inspection files
   */
  if (message.type === 'accela_file_downloaded') {
    return <InspectionFileDownloaded message={message} />;
  }

  return null;
}
